import { useState } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'

import { addressPropTypes } from '../../../common/propTypes'
import useTranslations from '../../../i18n/useTranslations'
import { ADDRESS_TYPE_CODE, STEPS } from '../../../common/constants'
import MultiLineSelect from '../../../ui/components/MultiLineSelect'
import AddressSectionOrigin from '../../../ui/views/ShippingSendMobile/AddressSectionOrigin'
import AddressEntry from '../../../ui/views/ShippingSendMobile/AddressEntry'

import useAddressEntryForm from './useAddressEntryForm'
import AddressBook from './AddressBook'

const OriginSection = ({
  userCenters,
  centerCode,
  originAddress,
  onChangeCenterCode,
  onConfirmAddress,
}) => {
  const t = useTranslations()
  const [isAddressConfirmed, setAddressIsConfirmed] = useState(
    Boolean(originAddress),
  )

  const {
    handleChangeAutocompleteAddress,
    handleChangeAutocompleteInput,
    autocompleteErrors,
    formik,
    enhancedFormik,
    addressInitialValues,
  } = useAddressEntryForm(setAddressIsConfirmed, onConfirmAddress)

  const [isAgendaOpen, setIsAgendaOpen] = useState(false)

  const openAgenda = () => {
    setIsAgendaOpen(true)
  }

  const closeAgenda = () => {
    setIsAgendaOpen(false)
  }

  return (
    <>
      {centerCode && userCenters?.length > 1 ? (
        <Box mb={2}>
          <MultiLineSelect
            label={t('noun:allocation-center')}
            options={userCenters}
            value={centerCode}
            onChange={e => onChangeCenterCode(e.target.value)}
          />
        </Box>
      ) : null}

      {isAddressConfirmed ? (
        <>
          <AddressSectionOrigin
            data={originAddress}
            onClickChange={() => setAddressIsConfirmed(false)}
          />
        </>
      ) : (
        <AddressEntry
          isHidden={isAddressConfirmed}
          title={t('noun:senderAddress2')}
          onChangeAutocompleteAddress={handleChangeAutocompleteAddress}
          onChangeAutocompleteInput={handleChangeAutocompleteInput}
          autocompleteErrors={autocompleteErrors}
          values={formik.values}
          touched={formik.touched}
          fieldErrors={enhancedFormik.fieldErrors}
          formErrors={enhancedFormik.formErrors}
          onChange={enhancedFormik.handleChange}
          onSubmit={enhancedFormik.handleSubmit}
          onBlur={formik.handleBlur}
          addressType={ADDRESS_TYPE_CODE.ORIGIN}
          openAgenda={openAgenda}
          formik={formik}
          isAddressConfirmed={isAddressConfirmed}
        />
      )}

      <AddressBook
        closeAgenda={closeAgenda}
        currentStep={STEPS.FROM}
        isOpen={isAgendaOpen}
        centreCode={centerCode}
        confirmDirection={direction => {
          setAddressIsConfirmed(true)
          formik.setValues(addressInitialValues)
          onConfirmAddress({
            ...direction,
            postalCode: {
              postalCode: direction.postalCode,
              city: direction.city,
            },
          })
        }}
      />
    </>
  )
}

OriginSection.propTypes = {
  centerCode: PropTypes.string,
  userCenters: PropTypes.array,
  originAddress: addressPropTypes,
  onChangeCenterCode: PropTypes.func,
  onConfirmAddress: PropTypes.func,
}

export default OriginSection
